import classNames from 'classnames';
import { ButtonHTMLAttributes } from 'react';
import LoadingIndicator from '../LoadingIndicator';
import './style.scss';

const Button = ({
  className,
  secondary,
  isLoading,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { secondary?: boolean; isLoading?: boolean }) => (
  <button
    className={classNames(
      'button',
      { 'button--secondary': secondary, 'button--loading': isLoading, 'button--disabled': props.disabled },
      className
    )}
    {...props}
  >
    {isLoading ? <LoadingIndicator /> : <span>{props.children}</span>}
  </button>
);

export default Button;
